import qs from "qs";
import { Axios as axios } from "utils/http";
import {
  publicHost,
  host,
  apiVersion,
  project,
  headers,
  postHeaders
} from "./apiConfig";
/* 
const host =
  location.host.indexOf("localhost") > -1
    ? "https://www.easy-mock.com/mock/5d303a066925514d8fc4b83b/farm"
    : ""; */
//  农业分类数组转树结构
function toTree(data) {
  data.forEach(item => {
    delete item.children;
  });
  const map = {};
  data.forEach(item => {
    map[item.agricultureProductTypeId] = item;
  });

  const val = [];
  data.forEach(item => {
    const parent = map[item.parentId];
    if (parent) {
      (parent.children || (parent.children = [])).push(item);
    } else {
      val.push(item);
    }
  });
  // console.log(val)
  return val;
}

//= ============================ 公共接口 start=======================================
// 城市三级联动-
export const getPartition = params =>
  axios.get(
    `${publicHost}/v1/web/env/provincialCascade/partition?${qs.stringify(
      params
    )}`
  );
export const getProvince = params =>
  axios.get(
    `${publicHost}/v1/web/env/provincialCascade/province?${qs.stringify(
      params
    )}`
  );
export const getCity = params =>
  axios.get(
    `${publicHost}/v1/web/env/provincialCascade/city?${qs.stringify(params)}`
  );
export const getArea = params =>
  axios.get(
    `${publicHost}/v1/web/env/provincialCascade/area?${qs.stringify(params)}`
  );
// 当前气候
export const getWether = params =>
  axios.get(
    `${publicHost}/v1/web/env/weather/now?city=${params.latitude}:${params.longitude}`
  );
// 七天天气 ${params.latitude}:${params.longitude}
export const get7Weather = params => {
  if (!params || !params.cityName) return Promise.reject();
  let city = params.cityName.replace(
    /市|自治区|特别行政区|地区|县|自治州|林区|朝鲜族|土家族|苗族|藏族|羌族|彝族|布依族|侗族|哈尼族|壮族|傣族|白族|景颇族|傈僳族|回族|蒙古|蒙古族|哈萨克/g,
    ""
  );
  if (city === "克孜勒苏柯尔克孜") city = "克州";
  return axios.get(
    `${publicHost}/v1/web/env/weather/7forecast?city=${encodeURIComponent(
      city
    )}`
  );
};

//= ============================ 公共接口 end =======================================

// ============================= 登录接口 start=======================================

// 登录前调用获取用户名
export const getWebUserName = params =>
  axios
    .post(
      `${host}/${apiVersion}${project}/account/app/getWebUserName`,
      qs.stringify(params),
      {},
      false
    )
    .then(res => res);
// 登录接口
export const requestLogin = params =>
  axios
    .post(
      `${host}/${apiVersion}${project}/common/admin/loginCheck`,
      qs.stringify(params),
      {},
      false
    )
    .then(res => res);
// 退出
export const logout = () =>
  axios
    .get(`${host}/${apiVersion}${project}/common/admin/logout?`)
    .then(res => res);

// 获取用户信息
export const getSessionAccount = () =>
  axios
    .get(`${host}/${apiVersion}${project}/account/getSessionAccount?`)
    .then(res => res);
// 获取自定义登录配置信息
export const getLoginConfigForNoLogin = params =>
  axios
    .get(
      `${host}/${apiVersion}${project}/screen/getLoginConfigForNoLogin?${qs.stringify(
        params
      )}`
    )
    .then(res => res);

// 获取大屏配置信息
export const getbigConfig = params =>
  axios
    .get(`${host}/${apiVersion}${project}/screen/getbigConfig?${qs.stringify(params)}`)
    .then(res => res);

// 短信验证码
export const sendVerifyCode = params =>
  axios
    .post(
      `${host}/${apiVersion}${project}/account/sendVerifyCode`,
      qs.stringify(params)
    )
    .then(res => res);
// 密码重置
export const retrievalPwd = params =>
  axios
    .post(
      `${host}/${apiVersion}${project}/account/retrievalPwd`,
      qs.stringify(params)
    )
    .then(res => res);
// 修改密码
export const resetPasswd = params =>
  axios
    .post(
      `${host}/${apiVersion}${project}/account/resetPasswd`,
      qs.stringify(params)
    )
    .then(res => res);

// ============================= 登录接口 end=======================================

// ============================= 农业接口 start=======================================

// 种植物top 10
export const getTopTen = params =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getCropRank?${qs.stringify(
      params
    )}`
  );

// 基地分布数据
export const getPartitionBaselandStatistics = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baseland/getPartitionBaselandStatistics?${qs.stringify(
      params
    )}`
  );
// 基地数据统计
export const getBaselandStatistics = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baseland/getBaselandStatistics?${qs.stringify(
      params
    )}`
  );
// 基地列表---传分页
export const getBaselandList = (page = {}, search = {}) =>
  axios
    .post(
      `${host}/${apiVersion}${project}/baseland/getBaseland?${qs.stringify(
        page
      )}`,
      search,
      {
        headers
      }
    )
    .then(res => {
      if (res.code === 0 && !res.data.list) {
        res.data.list = [];
      }
      return res;
    });
// 基地列表---不传分页
export const getBaselandMap = (search={}) =>
  axios
    .post(
      `${host}/${apiVersion}${project}/baseland/getBaselandMap`,
      search,
      {
        headers
      }
    )
    .then(res => {
      if (res.code === 0 && !res.data.list) {
        res.data.list = [];
      }
      return res;
    });
// 新增基地
export const addBaseland = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/addBaseland`,
    JSON.stringify(params),
    {
      headers
    },
    false
  );

// 获取基地点位
export const getBasePoint = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baseland/getBaselandPoint?${qs.stringify(
      params
    )}`
  );

// 修改基地信息
export const editBaseland = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/updateBaseland`,
    JSON.stringify(params),
    {
      headers
    },
    false
  );
// 修改基地点位
export const editBasePoint = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/updateBaselandPoint`,
    JSON.stringify(params),
    {
      headers
    }
  );

// 修改基地地块
export const editBaseBlock = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/updateBaselandBlock`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 批量添加基地地块
export const addBaselandBlockList = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/addBaselandBlockList`,
    qs.stringify(params, { allowDots: true }),
    {
      headers: postHeaders
    }
  );
// 批量修改基地地块
export const updateBaselandBlockList = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/updateBaselandBlockList`,
    qs.stringify(params, { allowDots: true }),
    {
      headers: postHeaders
    },
    false
  );
// 删除基地点位
export const delBasePoint = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/delBaselandPoint`,
    qs.stringify(params)
  );
// 删除基地地块
export const delBaseBlock = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/delBaselandBlock`,
    qs.stringify(params),
    {},
    false
  );
// 新增基地点位
export const addBasePoint = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/addBaselandPoint`,
    JSON.stringify(params),
    {
      headers
    }
  );
// 新增基地地块
export const addBaseBlock = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baseland/addBaselandBlock`,
    JSON.stringify(params),
    {
      headers
    }
  );

// 客户列表
export const getCustomer = params =>
  axios.get(
    `${host}/${apiVersion}${project}/customer/getCustomer?${qs.stringify(
      params
    )}`
  );
// 农作物生命周期
export const getCropCycle = params =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getAgricultureProductCycle?${qs.stringify(
      params
    )}`
  );
// 农作物种植基本知识
export const getCropKnowledge = params =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getCropBaseKnowledge?${qs.stringify(
      params
    )}`
  );
// 农作物当前生命周期因子标准
export const getCurrentCropCycleFactor = params =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getCurrentCropCycleFactor?${qs.stringify(
      params
    )}`
  );
// 营养功效
export const getCropEffect = params =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getCropEffect?${qs.stringify(
      params
    )}`
  );

// 农作物获取分类
export const getCropTypes = (params, origin) =>
  axios
    .get(
      `${host}/${apiVersion}${project}/agricultureProduct/getAgricultureProductTypes?${qs.stringify(
        params
      )}`
    )
    .then(res => {
      const copy = Object.assign({}, res);
      if (origin) {
        return res.data;
      }
      return {
        origin: res.data,
        treeData: toTree(copy.data)
      };
    });

// 微型气象仪检测项目情况
export const getMeteorographMonitorInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getMeteorographMonitorInfo?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );
// 光谱监测仪检测项目情况
export const getSpectrometerMonitorInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getSpectrometerMonitorInfo?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );

// 土壤检测仪项目情况
export const getSoilMonitorInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getSoilMonitorInfo?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );
// 叶绿素检测仪项目情况
export const getChlorophyllMonitorInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getChlorophyllMonitorInfo?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );

// 农作物最新监测数据
export const getNewestMonitor = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getNewestMonitor?${qs.stringify(
      params
    )}`
  );
// 农作物最新监测数据的分级
export const getSoilRating = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getSoilRating?${qs.stringify(
      params
    )}`
  );
// 获取当前生命周期的疾病
export const getCurrentDisaster = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getCurrentDisaster?${qs.stringify(
      params
    )}`
  );
// 查询各个项目的小时值
export const getMonitorDetailHour = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getMonitorDetailHour?${qs.stringify(
      params
    )}`
  );
// 设备列表
export const getDeviceList = (page = {}, search = {}) =>
  axios.post(`${host}/${apiVersion}${project}/device/getDeviceList`, search, {
    headers
  });
// 导入设备
export const equipImport = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/uploadDevice`,
    params,
    {
      headers: { "content-type": "multipart/form-data" }
    },
    false
  );
// 获取设备类型
export const getDeviceTypes = () =>
  axios.get(`${host}/${apiVersion}${project}/device/getDeviceTypes?`);

// 设备列表分页
export const pageDevice = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/getBaselandDevice`,
    JSON.stringify(params),
    { headers }
  );
// 设备分布
export const DeviceDistributed = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getDeviceDistributed?${qs.stringify(
      params
    )}`
  );
// 统计七大分区设备分布
export const getPartitionDeviceStatistics = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getPartitionDeviceStatistics?${qs.stringify(
      params
    )}`
  );
// 统计设备
export const getDeviceStatistics = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getDeviceStatistics?${qs.stringify(
      params
    )}`
  );
// 实况监控
export const getNewestMonitorBaselandDevice = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baseland/getNewestMonitorBaselandDevice?${qs.stringify(
      params
    )}`
  );

// 修改默认作物图片
// imageType 1基地实景图；2农作物图片；3app中农作物图片；4农作物详情图片；5病虫害图片
export const editDefaultCropIcon = params =>
  axios.post(
    `${host}/${apiVersion}${project}/agricultureProduct/updateIcon`,
    qs.stringify(params)
  );
// 修改作物图片
export const editCropIcon = params =>
  axios.post(
    `${host}/${apiVersion}${project}/agricultureProduct/updateIcon`,
    qs.stringify(params)
  );
// 修改APP作物图片
export const editCropAPPIcon = params =>
  axios.post(
    `${host}/${apiVersion}${project}/agricultureProduct/updateIcon`,
    qs.stringify(params)
  );
// v1.1
/* --------------------基地评级------------------*/
// 获取基地评级
export const getGradeSettingData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/gradeSetting/getGradeSettingData?${qs.stringify(
      params
    )}`
  );

// 更新基地评级
export const updateGradeSettingData = params =>
  axios.post(
    `${host}/${apiVersion}${project}/gradeSetting/updateGradeSettingData`,
    JSON.stringify(params),
    { headers }
  );

/* --------------------农业分类------------------*/
// 查询农业分类
export const nyQueryCropTypeList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/agricultureProduct/getAgricultureProductTypeList?${qs.stringify(
      page
    )}`,
    search,
    { headers }
  );
// 查看农业分类
export const getCropTypeDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getCropTypeDetail?${qs.stringify(
      params
    )}`
  );
/* --------------------农作物------------------*/
// getAllCropType
export const getAllCropType = () =>
  axios.get(
    `${host}/${apiVersion}${project}/agricultureProduct/getAllCropType`
  );
// 查询农作物数据库
export const queryCropDatabase = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/agricultureProduct/queryCropDatabase?${qs.stringify(
      page
    )}`,
    search,
    { headers }
  );
/* --------------------病虫害------------------*/

// 查询病虫害数据库
export const getDisasterDatabase = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/disaster/getDisasterDatabase?${qs.stringify(
      page
    )}`,
    search,
    { headers }
  );
// 查看病虫害信息
export const getDisasterInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/disaster/getDisasterInfo?${qs.stringify(
      params
    )}`
  );
/* --------------------农事------------------*/

// 获取新增编辑农事分类下拉选项
export const getAllFarmTypeByMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/farmType/getAllFarmTypeByMechanism?${qs.stringify(
      params
    )}`
  );

// 获取所有农事分类
export const getAllFarmType = params =>
  axios.get(
    `${host}/${apiVersion}${project}/farmType/getAllFarmType?${qs.stringify(
      params
    )}`
  );
// 获取所有农事分类2
export const selectAllFarmType = params =>
  axios.get(
    `${host}/${apiVersion}${project}/farmType/selectAllFarmType?${qs.stringify(
      params
    )}`
  );
// 获取农事操作列表
export const getFarmOperateList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/farmType/getFarmOperateList?${qs.stringify(
      params
    )}`
  );
// 查询农事分类列表
export const queryFarmClassifyList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/farmType/queryFarmClassifyList?${qs.stringify(
      page
    )}`,
    search,
    { headers }
  );
// 查询农事分类信息详情
export const queryFarmClassifyDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/farmType/queryFarmClassifyDetail?${qs.stringify(
      params
    )}`
  );
// 禁用农事分类信息
export const forbidFarmClassify = params =>
  axios.post(
    `${host}/${apiVersion}${project}/farmType/forbidFarmClassify`,
    JSON.stringify(params),
    { headers }
  );
// 新增/更新农事分类信息
export const updateFarmClassify = params =>
  axios.post(
    `${host}/${apiVersion}${project}/farmType/updateFarmClassify`,
    JSON.stringify(params),
    { headers }
  );
// 查询农事记录列表
export const queryFarmRecordList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/farmType/queryFarmRecordList?${qs.stringify(
      page
    )}`,
    search,
    { headers }
  );
// 查询农事记录详情
export const queryFarmRecordDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/farmType/queryFarmRecordDetail?${qs.stringify(
      params
    )}`
  );

/* --------------------首页------------------*/
// 首页基地等基础信息
export const queryIndexBaseData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryIndexBaseData?${qs.stringify(
      params
    )}`
  );
// 实时监测数据
export const queryCropWarningRealTime = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryCropWarningRealTime?${qs.stringify(
      params
    )}`
  );

// 病虫害监测数据
export const queryPestMonitor = params =>
  axios.get(
    `${host}/${apiVersion}/web/pest/pestResult/pestMonitor?${qs.stringify(
      params
    )}`
  );

// 用户增长图
export const queryUserIncreaseData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/user/queryUserIncreaseData?${qs.stringify(
      params
    )}`
  );

// 设备正常运行情况

// 分配设备到基地
export const bindDeviceToBaseland = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/bindDeviceToBaseland`,
    JSON.stringify(params),
    { headers }
  );
// 所有基地列表
export const getAllBaselandList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baseland/getAllBaselandList?${qs.stringify(
      params
    )}`
  );
// 农产品评级
export const queryCropRatingData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryCropRatingData?${qs.stringify(
      params
    )}`
  );
// 首页消息提醒列表数据
export const queryMessageReminding = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryMessageReminding?${qs.stringify(
      params
    )}`
  );

/* --------------------数据报表------------------*/
// 查询作物预警监测列表数据-ysz
export const queryCropWarningList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryCropWarningList?${qs.stringify(
      params
    )}`
  );
// 查询作物预警分析数据-ysz
export const queryCropWarningAnalysis = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryCropWarningAnalysis?${qs.stringify(
      params
    )}`
  );
// 查询作物预警监测明细列表数据-ysz
export const queryCropWarningDetailList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryCropWarningDetailList?${qs.stringify(
      params
    )}`
  );
// 查询用户信息列表-ysz
export const getUserList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/user/getUserList?${qs.stringify(params)}`
  );
// 查询用户信息详情-ysz
export const getUserDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/user/getUserDetail?${qs.stringify(params)}`
  );
// //获取所有基地列表-ysz
// export const getBaseland = params =>{
//     return axios.get(`/${apiVersion}/web/telecom/baseland/getBaseland?`+qs.stringify(params))
// }
// 查询土壤品质分析数据-ysz
export const querySoilQualityData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/querySoilQualityData?${qs.stringify(
      params
    )}`
  );
// 查询土壤品质分析列表数据-ysz
export const querySoilQualityList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/querySoilQualityList?${qs.stringify(
      params
    )}`
  );
// 查询基地评级排行榜前十数据-ysz
export const queryBaselandGradingTop = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryBaselandGradingTop?${qs.stringify(
      params
    )}`
  );
// 查询基地评级明细数据-ysz
export const queryBaselandGradingDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/statistic/queryBaselandGradingDetail?${qs.stringify(
      params
    )}`
  );
